<script setup>
import { useGlobalStore } from '@/stores/GlobalStore'

const globalStore = useGlobalStore()

// Optional action button (e.g. "Refresh page"). Driven by
// `toastNotification.action = { label, icon, type }`. `type: 'reload'`
// reloads the page; any other action just dismisses the toast.
const handleAction = () => {
  const action = globalStore.toastNotification.action
  globalStore.toastNotification.show = false
  if (action?.type === 'reload') window.location.reload()
}
</script>

<template>
  <Transition name="fade">
    <div>
      <section
        class="fixed bottom-4 left-20 shadow rounded-lg p-4 bg-white w-[372px] text-sm z-[1099]"
        :class="{
          'bg-white-50 border': globalStore.toastNotification.type === 'success',
          'bg-red-50 border border-red-500': globalStore.toastNotification.type === 'error'
        }"
        v-if="globalStore.toastNotification.show"
      >
        <section class="flex items-start gap-x-3">
          
          <section class="flex-1">
            <header class="flex items-start justify-between mb-1 flex-1" v-if="globalStore.toastNotification.title">
              <div class="flex items-center gap-x-2 flex-1">
                <Icon icon="heroicons:check-circle" class="text-xl text-green-500" />
                <h3 class="font-semibold">{{ globalStore.toastNotification.title }}</h3>
              </div>
              
              <button @click="globalStore.toastNotification.show = false">
                <Icon icon="heroicons:x-mark" class="text-base" />
              </button>
            </header>
            <div class="flex items-center gap-x-2"> 
              <p 
                class="text-gray-600 text-xs"
                :class="{
                  'text-gray-600': globalStore.toastNotification.type === 'success',
                  'text-red-600': globalStore.toastNotification.type === 'error'
                }"
              > 
                {{ globalStore.toastNotification.message }} 
              </p>

              <button @click="globalStore.toastNotification.show = false" v-if="!globalStore.toastNotification.title">
                <Icon icon="heroicons:x-mark" class="text-base" />
              </button>
            </div>

            <button
              v-if="globalStore.toastNotification.action"
              class="mt-2 font-semibold text-tint-1 text-xs transition hover:text-tint-2 flex items-center gap-1"
              @click="handleAction"
            >
              <Icon
                v-if="globalStore.toastNotification.action.icon"
                :icon="globalStore.toastNotification.action.icon"
                class="text-sm"
              />
              {{ globalStore.toastNotification.action.label }}
            </button>

            <!-- <p class="text-gray-600 text-xs mb-3"> There's an server outage </p> -->

            <!-- <button v-if="!globalStore.errors && !connectionStore.exportedChannelInfo.failed_cards" class="font-semibold text-tint-1 transition hover:text-tint-2" @click="() => handleRedirectToExportHistory(connectionStore.exportedChannelInfo?.key)">
              View in Export History
            </button>
            <button v-else-if="(globalStore.errors || connectionStore.exportedChannelInfo.failed_cards) && ['ebay', 'ebay-direct'].includes(connectionStore.exportedChannelInfo?.key)" class="font-semibold text-tint-1 transition hover:text-tint-2" @click="handleTryAgain">
              View Details
            </button>
            <button v-else class="font-semibold text-tint-1 transition hover:text-tint-2">
              Try Again
            </button> -->
          </section>
        </section>
      </section>
    </div>
  </Transition>
</template>